'use strict';

/* globals define, ajaxify, $, socket, app, config */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/memoryGame/memory-games-list', [
	'translator',
	'benchpress',
	'slugify',
	'bootbox',
], function (translator, Benchpress, slugify, bootbox) {
	var	MemoryGamesList = {};

	MemoryGamesList.init = function () {
		$('button[data-action="create"]').on('click', MemoryGamesList.throwCreateModal);
	};

	MemoryGamesList.throwCreateModal = function () {
		Benchpress.parse('memoryGame/create-memory-game', {}, function (html) {
			var modal = bootbox.dialog({
				title: '[[memory_game:new-game]]',
				message: html,
				buttons: {
					save: {
						label: '[[global:save]]',
						className: 'btn-primary',
						callback: submit,
					},
				},
			});

			function submit() {
				var formData = modal.find('form').serializeObject();

				if (!formData.title.length) {
					return app.alertError('[[memory-game:game-title-required]]');
				}

				MemoryGamesList.create(formData);

				modal.modal('hide');

				return false;
			}

			modal.find('form').on('submit', submit);
		});
	};

	MemoryGamesList.create = function (payload) {
		var game = {
			title: payload.title,
			description: payload.description,
		};

		socket.emit('plugins.memoryGames.createMemoryGame', game, function (err, game) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'memory_game_created',
				message: '[[memory_games:game-created]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('memory-games/' + game.gameId + '/' + encodeURIComponent(slugify(game.title)) + '/editor');
		});
	};

	return MemoryGamesList;
});
